import { useDebouncedEffect } from '@coverright/utils';
import { mainBackendApolloClient } from '@coverright/data-access/apollo-clients';
import { PlanSelector, PlanSelectorPlan, PlanSelectorProps } from './plan-selector';
import { useState } from 'react';
import { useAdminMaPlansLazyQuery } from '@coverright/data-access/medicare';
import { Field, SnpType, Sort } from '@coverright/data-access/types/medicare';
import { Box } from '@mui/material';
import { Tooltip } from '@coverright/ui/inputs';

export const MaPlanSelector = (props: PlanSelectorProps) => {
  const {zip, county, planYear, carrierName, onLoaded} = props;

  const [plans, setPlans] = useState<PlanSelectorPlan[]>([]);

  const [getPlans, {loading}] = useAdminMaPlansLazyQuery({
    client: mainBackendApolloClient,
    onCompleted: data => {
      const planList = [...data.plans?.data, ...data.snpPlans?.data];
      setPlans(planList);
      onLoaded && onLoaded(planList);
    }
  })

  useDebouncedEffect(() => {
    if (county && zip) {
      const filter = {
        countyName: county,
        zip,
        companies: carrierName ? [carrierName] : null,
        showAllPlans: true,
        planYear
      };

      getPlans({
        variables: {
          page: {
            size: 1000,
            page: 0
          },
          sort: [{direction: Sort.Asc, field: Field.Name}],
          filter,
          snpFilter: {
            ...filter,
            SNPTypes: [SnpType.DSnp]
          }
        }
      })
    }
  }, 300, [carrierName, county, zip, planYear])

  return <Tooltip sx={{flex: 1, display: 'flex'}} title={carrierName ? '' : 'You have to select carrier to select plan'}>
    <Box>
      <PlanSelector {...props} plans={plans} loading={loading} />
    </Box>
  </Tooltip>
};
